import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

import AuthLayout from '@/layouts/Auth'
import DashboardLayout from '@/layouts/Dashboard'
import Error404 from '@/pages/Error404'
import threeDSecureSuccess from '@/pages/3dSecureSuccess'
import threeDSecureError from '@/pages/3dSecureError'

import ForgotPassword from '@/pages/ForgotPassword'
import ForgotPasswordReset from '@/pages/ForgotPasswordReset'

import Register from '@/pages/Register'
import Login from '@/pages/Login'
import WizardPage from '@/pages/WizardPage/index.vue'

//Specialist specific views
import AnytimeMeetings from '@/pages/specialist/AnytimeMeetingsPage'
import SpecialistSettings from '@/pages/specialist/SettingsPage'
import SpecialistStats from '@/pages/specialist/StatsPage'
import SpecialistArticles from '@/pages/specialist/ArticlesPage'
import TransactionsPage from '@/pages/specialist/TransactionsPage'

//Client specific views
import ClientBillingInfoPage from '@/pages/client/BillingInfoPage'
import ClientServices from '@/pages/client/ServicesPage'
import ClientPayments from '@/pages/client/PaymentsPage'
import ClientSettings from '@/pages/client/SettingsPage'
import ClientTopup from '@/pages/client/TopupPage'
import ClientCompleteFacebookEmail from '@/pages/client/CompleteFacebookEmail'

//Common views
import AppointmentsPage from '@/pages/AppointmentsPage'
import AppointmentsHistoryPage from '@/pages/AppointmentsHistoryPage'
import SpecialistsPage from '@/pages/SpecialistsPage'
import SpecialistPage from '@/pages/SpecialistPage'
import ArticlesPage from '@/pages/ArticlesPage'
import ArticlePage from '@/pages/ArticlePage'
import MeetingRoom from '@/pages/MeetingRoom'
import HelpPage from '@/pages/HelpPage'
import LegalNotice from '@/pages/LegalNotice'
import NotificationsPage from '@/pages/NotificationsPage'

import AnytimeMeetingRoom from '@/pages/AnytimeMeetingRoom'

const router = new Router({
    mode: 'history',
    routes: [
        {
            path: '/specialist',
            role: 'specialist',
            component: DashboardLayout,
            beforeEnter: (to, from, next) => {
                var address = localStorage.getItem('address');
                var token = localStorage.getItem('token');
                var role = localStorage.getItem('role');
                if(!token || !role || role != 'specialist') {
                    localStorage.clear();
                    next('/login');
                } 
                // else if (address !== 'true') {
                //     next('/client/one-more-step');
                // }
                else if (to.path === '/specialist' || to.path === '/specialist/') {
                    next('/specialist/stats');
                } else
                    next();
            },
            children: [
                // Specialist's routes
                {
                    path: 'stats',
                    name: 'Statisticile mele',
                    component: SpecialistStats,
                    icon: 'fas fa-chart-bar',
                    role: 'specialist',
                    sidebar: true
                },
                {
                    path: 'appointments',
                    name: 'Programări',
                    component: AppointmentsPage,
                    icon: 'far fa-calendar',
                    role: 'specialist',
                    sidebar: true
                },
                {
                    path: 'appointments/now',
                    name: 'Ședințe acum',
                    component: AnytimeMeetings,
                    icon: 'fas fa-user-clock',
                    role: 'specialist',
                    sidebar: true,
                    hasCounter: true
                },
                {
                    path: 'appointments/history',
                    name: 'Istoric Programări',
                    component: AppointmentsHistoryPage,
                    icon: 'far fa-history',
                    role: 'specialist',
                    sidebar: false
                },
                {
                    path: 'settings',
                    name: 'Setări',
                    component: SpecialistSettings,
                    icon: 'fa fa-cog',
                    role: 'specialist',
                    sidebar: false

                },
                {
                    path: 'transactions',
                    name: 'Tranzacții',
                    component: TransactionsPage,
                    icon: 'far fa-money-bill-wave',
                    role: 'specialist',
                    sidebar: false
                },
                /*
                {
                    path: 'stats',
                    name: 'Plati',
                    component: SpecialistStats,
                    icon: 'far fa-money-bill-alt',
                    role: 'specialist',
                    sidebar: false
                },
                */
                {
                    path: 'settings#disponibilitate',
                    name: 'Disponibilitate',
                    component: SpecialistSettings,
                    icon: 'fa fa-clock',
                    role: 'specialist',
                    sidebar: true

                },
                {
                    path: 'my_articles',
                    name: 'Articolele mele',
                    component: SpecialistArticles,
                    icon: 'fas fa-cubes',
                    role: 'specialist',
                    sidebar: true
                }
            ]
        },
        {
            path: '/client',
            role: 'client',
            component: DashboardLayout,
            beforeEnter: (to, from, next) => {
                var address = localStorage.getItem('address');
                var token = localStorage.getItem('token');
                var role = localStorage.getItem('role');
                if(!token || !role || role != 'client') {
                    localStorage.clear();
                    next('/login');
                } 
                // else if (address !== 'true') {
                //     next('/client/one-more-step');
                //     // // JUST FOR REDIRECT ON DASHBOARD PAGE TO TEST THE LAYOUT - THIS WILL BE REMOVED
                //     // next('/client/appointments');
                //     // //
                // }
                else if (to.path === '/client' || to.path === '/client/') {
                    next('/client/appointments');
                } else
                    next();
            },
            // Client's routes
            children: [
                {
                    path: 'settings',
                    name: 'Setări cont',
                    component: ClientSettings,
                    icon: 'fas fa-cog',
                    role: 'client',
                    sidebar: false
                },
                {
                    path: 'appointments',
                    name: 'Programări',
                    component: AppointmentsPage,
                    icon: 'far fa-calendar',
                    role: 'client',
                    sidebar: true
                },
                {
                    path: 'appointments/history',
                    name: 'Istoric Programări',
                    component: AppointmentsHistoryPage,
                    icon: 'far fa-history',
                    role: 'client',
                    sidebar: false
                },
                {
                    path: 'meetings',
                    name: 'Ședințe disponibile',
                    component: ClientServices,
                    icon: 'far fa-handshake',
                    role: 'client',
                    sidebar: true
                },
                {
                    path: 'payments',
                    name: 'Plăți',
                    component: ClientPayments,
                    icon: 'far fa-money-bill-alt',
                    role: 'client',
                    sidebar: false
                },
                {
                    path: 'topup',
                    name: 'Adaugă credite',
                    component: ClientTopup,
                    icon: 'fas fa-wallet',
                    role: 'client',
                    sidebar: false //Removed from sidebar by ~RJ | 20.09.21 -> Topup page can only be accessed from Anytime appointments -> insufficient funds modal
                }
            ]
        },
        {
            path: '',
            name: 'common',
            component: DashboardLayout,
            role: null,
            beforeEnter: (to, from, next) => {
                var address = localStorage.getItem('address');
                var token = localStorage.getItem('token');
                var role = localStorage.getItem('role');
                if(!token || !role) {
                    localStorage.clear();
                    next('/login');
                } 
                // else if (address !== 'true') {
                //     next('/client/one-more-step');
                // } 
                else if (to.path === '/') {
                    next('/client/appointments');
                } else
                    next();
            },
            children: [
                {
                    path: '/articles',
                    slug: '/:category?',
                    name: 'Articole',
                    component: ArticlesPage,
                    icon: 'far fa-newspaper',
                    role: null,
                    sidebar: true
                },
                {
                    path: '/articles/:slug',
                    name: 'Articol',
                    component: ArticlePage,
                    icon: 'far fa-newspaper',
                    role: null,
                    sidebar: false
                },
                {
                    path: '/specialists',
                    slug: '/:slug?',
                    name: 'Specialiști',
                    component: SpecialistsPage,
                    icon: 'fas fa-user-md',
                    role: null,
                    sidebar: true
                },
                {
                    path: '/specialists/profile/:id',
                    name: 'Specialist',
                    component: SpecialistPage,
                    icon: 'fas fa-comment-dollar',
                    role: null,
                    sidebar: false
                },
                {
                    path: '/specialists/:slug',
                    name: 'Specialiști',
                    component: SpecialistsPage,
                    icon: 'fas fa-comment-dollar',
                    role: null,
                    sidebar: false
                },
                {
                    path: '/help',
                    name: 'Ajutor',
                    component: HelpPage,
                    icon: 'far fa-question-circle',
                    sidebar: true
                },
                {
                    path: '/help/:slug',
                    name: 'Termeni și condiții',
                    component: LegalNotice,
                    icon: 'fas fa-cog',
                    role: null,
                    sidebar: false
                },
                {
                    path: '/notifications',
                    name: 'Toate notificările',
                    component: NotificationsPage,
                    icon: 'fas fa-info',
                    role: null,
                    sidebar: false
                },
                {
                    path: 'error',
                    name: 'error404',
                    component: Error404
                }
            ]
        },
        {
            path: '/3dSecureSuccess',
            name: '3dSecure Success',
            component: threeDSecureSuccess
        },
        {
            path: '/3dSecureError',
            name: '3dSecure Error',
            component: threeDSecureError
        },
        {
            path: '/meetingroom',
            name: 'MeetingRoom',
            component: MeetingRoom,
            icon: 'far fa-video',
            beforeEnter: (to, from, next) => {
                if(to.query.token) {
                    localStorage.setItem('roomAccessToken', to.query.token);
                    next();
                } else {
                    localStorage.removeItem('roomAccessToken');
                    next('/'+localStorage.getItem('role')+'/appointments');
                }
            }
        },
        {
            path: '/anytime-meetingroom',
            name: 'AnytimeMeetingRoom',
            component: AnytimeMeetingRoom,
            icon: 'far fa-video',
            beforeEnter: (to, from, next) => {
                if(to.query.token) {
                    console.log(to.query.token);
                    localStorage.setItem('anytimeRoomAccessToken', to.query.token);
                    next();
                } else {
                    localStorage.removeItem('anytimeRoomAccessToken');
                    next('/'+localStorage.getItem('role')+'/appointments');
                }
            }
        },
        {
            path: '/client/one-more-step',
            name: 'Incă un pas',
            component: ClientBillingInfoPage,
            icon: 'fas fa-file-invoice-dollar',
            role: 'client',
            sidebar: false,
            beforeEnter: (to, from, next) => {
                var address = localStorage.getItem('address');
                var token = localStorage.getItem('token');
                var role = localStorage.getItem('role');
                if(!token || !role || role != 'client') {
                    localStorage.clear();
                    next('/login');
                } else if (address === 'true' || to.path === '/client' || to.path === '/client/') {
                    next('/client/appointments');
                } else
                    next();
            },
        },
        {
            path: '/admin/login',
            name: 'Logare administrator',
            beforeEnter: (to, from, next) => {
                // Clear old login
                localStorage.clear();
                
                const queryString = window.location.search;
                const urlParams = new URLSearchParams(queryString);
                const token = urlParams.get('token');
                const role = urlParams.get('role');
                const hasAddress = urlParams.get('hasAddress');
                
                if(!token || !role)
                    next('login');
                else {
                    localStorage.setItem('role', role);
                    localStorage.setItem('token', token);
                    localStorage.setItem('address', hasAddress);
                    
                    next('/'+role+'/appointments');
                }
            }
        },
        {
            path: '/client/facebook/complete-email',
            name: 'Completează adresa de e-mail',
            component: ClientCompleteFacebookEmail,
            role: 'client',
            sidebar: false,
            beforeEnter: (to, from, next) => {
                var address = localStorage.getItem('address');
                var token = localStorage.getItem('token');
                var role = localStorage.getItem('role');
                
                if(token && role && address) {
                    next('/client/appointments');
                } else {
                    next();
                }
            },
        },
        // Routes that does not require auth
        {
            path: '/',
            component: AuthLayout,
            beforeEnter: (to, from, next) => {
                var token = localStorage.getItem('token');
                var role = localStorage.getItem('role');

                if(token && role) {
                    var invite_step = localStorage.getItem('invite_step');

                    if(invite_step && invite_step <= 6)
                        next();
                    else
                        next('/'+localStorage.getItem('role')+'/appointments');
                } else {
                    next();
                }
            },
            children: [
                {
                    path: '/register',
                    name: 'Înregistrare',
                    component: Register
                },
                {
                    path: '/forgot/password',
                    name: 'Recuperare parolă',
                    component: ForgotPassword
                },
                {
                    path: '/reset_password_form/:secret',
                    name: 'Resetare parolă',
                    component: ForgotPasswordReset
                },
                {
                    path: '/login',
                    name: 'Intră în cont',
                    component: Login
                },
                {
                    path: '/specialist/login',
                    name: 'Intră in cont',
                    component: Login,
                    beforeEnter: (to, from, next) => {
                        // localStorage.clear();
                        // Paul: Am comentat linia asta, dar nu știu exact dacă este pusă cu un scop sau din greșeală
                        next();
                    }
                },
                {
                    path: '/wizard/:inviteToken',
                    name: 'Setare profil',
                    component: WizardPage
                },
                {
                    path: '*',
                    redirect: '/error'
                }
            ]
        }
    ]
})

router.beforeEach((to, from, next) => {
    if (to.name) {
        document.title = `${ to.name } · NEXYO`;
    } else {
        document.title = 'NEXYO';
    }
    next();
});

export default router;
